(ns storrito.editor.centering
  (:require [storrito.instagram.story.editor.dimension :as dimension]
            [storrito.fabricjs.state :as f]))

;; Concept:
;;
;; Centers a FabricJS object on the FabricJS canvas of the story
;; editor.

(defn center-y [fabric-object]
  (let [dimensions (dimension/dimensions dimension/story-image)]
    (- (/ (:canvas/height dimensions)
          2)
       (* (:height fabric-object)
          (:scaleY fabric-object)
          0.5))))

(defn center-x [fabric-object]
  (let [dimensions (dimension/dimensions dimension/story-image)
        image-width (:image/width dimensions)]
    (- (/ (:canvas/width dimensions)
          2)
       (* (:width fabric-object)
          (:scaleX fabric-object)
          0.5))))

(defn center!
  "Centers the object in the middle of the canvas."
  [fabric-object]
  (f/assoc! fabric-object
            :top (center-y fabric-object)
            :left (center-x fabric-object)))
